<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  import { getCopy } from "../../lib/stores/copy";
  import Button from "../Button.svelte";
  import { checkIfStepShouldBeRendered, continueHandler, type SkillTest } from "../../lib/helpers/steps/skillTest";
  import CustomHtml from "../CustomHTML.svelte";
  import TextArea from "../Inputs/TextArea.svelte";
  import { settingsStore } from "../../lib/stores/settings";
  import { onMount } from "svelte";
  import Youtube from "../Youtube.svelte";

  export let currentRoute;
  let answer = "";

  onMount(checkIfStepShouldBeRendered);

  const handleContinue = () => continueHandler(answer);

  $: copy = $getCopy("skillTest") as Record<string, string>;
  $: skillTestConfig = $settingsStore?.skillTest as SkillTest;
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />

    <div class="flex flex-col lg:flex-row mt-4 lg:mt-8 gap-4">
      <div class="w-full lg:w-fit min-w-96">
        <TextArea placeholder={skillTestConfig.question} bind:value={answer} />
      </div>
    </div>

    <div class="mt-4 lg:mt-10 flex flex-col gap-4">
      <Button class="w-full lg:w-fit" primary disabled={!answer} on:click={handleContinue}>
        {copy.continueButtonCopy}
      </Button>
    </div>

    <CustomHtml customHtml={copy.customHtml} />
    <Youtube videoId={copy.videoId} />
  </svelte:fragment>
</BaseStep>
